import { render, staticRenderFns } from "./live.vue?vue&type=template&id=23c13781&scoped=true&"
import script from "./live.vue?vue&type=script&lang=ts&"
export * from "./live.vue?vue&type=script&lang=ts&"
import style0 from "./live.vue?vue&type=style&index=0&id=23c13781&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c13781",
  null
  
)

export default component.exports